import { useMutation } from '@tanstack/react-query';
import { MailCheck } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router';
import { toast } from 'sonner';

import { api, ensureOk } from '@/api/client';
import { mensajeDe } from '@/api/errors';
import { recaptchaHeader, recaptchaToken } from '@/auth/recaptcha';

import { AuthLayout, Campo } from './AuthLayout';

export function RecuperarPage() {
  const [email, setEmail] = useState('');
  const enviar = useMutation({
    mutationFn: async () => {
      const token = await recaptchaToken('admin_forgot_password');
      await ensureOk(
        api.POST('/api/v1/admin/auth/password/forgot', {
          body: { email: email.trim() },
          headers: recaptchaHeader(token),
        }),
      );
    },
    onError: (e) => toast.error(mensajeDe(e)),
  });

  return (
    <AuthLayout titulo="Recuperar contraseña">
      {enviar.isSuccess ? (
        <div className="space-y-4 text-center">
          <MailCheck className="mx-auto text-cian-texto" size={40} aria-hidden />
          <p className="text-texto-2">
            Si el correo pertenece a una cuenta del panel, te enviamos un enlace para restablecer la
            contraseña. Vence en una hora.
          </p>
          <Link to="/login" className="btn-cs btn-contorno w-full">
            Volver al inicio de sesión
          </Link>
        </div>
      ) : (
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            enviar.mutate();
          }}
        >
          <Campo etiqueta="Correo electrónico">
            <input
              type="email"
              className="input-vidrio"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </Campo>
          <button type="submit" className="btn-cs btn-primario w-full" disabled={enviar.isPending}>
            {enviar.isPending ? 'Enviando…' : 'Enviar enlace'}
          </button>
          <p className="text-center text-sm">
            <Link to="/login">Volver al inicio de sesión</Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
